import { supabase } from "../supabase";
import type { CertState } from "../types";

interface CertRow {
  profile_id: string;
  medical: "current" | "missing" | "expired" | null;
  student_cert: "current" | "missing" | "expired" | null;
  instructor: "current" | "missing" | "expired" | null;
}

export async function mapBySchool(schoolId: string): Promise<Record<string, CertState>> {
  const { data, error } = await supabase
    .from("cert_states")
    .select("profile_id, medical, student_cert, instructor, profiles!inner(school_id)")
    .eq("profiles.school_id", schoolId);
  if (error) throw error;
  const out: Record<string, CertState> = {};
  for (const r of (data ?? []) as (CertRow & { profiles: unknown })[]) {
    const cs: CertState = {};
    if (r.medical) cs.medical = r.medical;
    if (r.student_cert) cs.studentCert = r.student_cert;
    if (r.instructor) cs.instructor = r.instructor;
    out[r.profile_id] = cs;
  }
  return out;
}
